// Mirrors: App\Enums\FrontendSeasonStatus (core)
export const SeasonStatus = Object.freeze({
    CLOSING: 'closing',
    SCORING: 'scoring',
    ACTIVE: 'active',
});
